import React, { Component } from 'react'
import { Modal, Button, Checkbox } from 'antd'
import Dropzone from 'react-dropzone'
import className from 'classnames'
import { FileUploader, Table } from './components'
import { AssignTags } from '../../Parts'

export default class extends Component {
  handleCancel = (e) => {
    const { closeModal, setUploadedDefaults, getStorage } = this.props
    if (closeModal) {
      closeModal()
      setUploadedDefaults()
      getStorage()
    }
  }

  handleDrop = (acceptedFiles) => {
    const { addAcceptedFiles } = this.props

    addAcceptedFiles(acceptedFiles)
  }

  handleSelectAll = () => {
    const { uploadedTable, uploadedFiles, updateUploadedTable } = this.props
    if (uploadedTable.keys.length !== uploadedFiles.length) {
      updateUploadedTable(true)
    } else {
      updateUploadedTable(false)
    }
  }

  render () {
    const { status, acceptedFiles, uploadedTable, uploadedFiles } = this.props

    return (
      <Modal
        wrapClassName='vertical-center-modal'
        title='Upload Files'
        visible={status}
        onCancel={this.handleCancel}
        destroyOnClose
        footer={
          <div className='controls-between'>
            { uploadedFiles.length > 0
              ? <Checkbox
                style={{ padding: '.5rem .8rem' }}
                checked={uploadedTable.keys.length === uploadedFiles.length}
                indeterminate={uploadedTable.keys.length && uploadedTable.keys.length !== uploadedFiles.length}
                onClick={this.handleSelectAll}
              >Select all</Checkbox>
              : <div />}
            <div className='controls-between'>
              { uploadedTable.keys.length > 0 && <AssignTags mode={'upload'} /> }
              <Button
                key='submit'
                type='indigo'
                onClick={this.handleCancel}
                style={{ marginLeft: '2rem' }}
              >Done</Button>
            </div>
          </div>

        }
      >
        <Dropzone
          onDrop={this.handleDrop}
        >
          {({ getRootProps, getInputProps, isDragActive }) =>
            <div {...getRootProps()} className={className('dragger', { 'dragger_active': isDragActive })}>
              <div className='dragger__heading'>Drag &amp; Drop content here or</div>
              <div className='dragger__control'>
                <input {...getInputProps()} />
                <Button type='indigo'>Select content</Button>
              </div>
              <div className='dragger__sub'>Maximum file size is 200 Mb.</div>
            </div>
          }
        </Dropzone>

        <div className='upload'>
          <div className='upload__list'>
            { acceptedFiles.length ? acceptedFiles.map((file, index) =>
              <div className='upload__item' key={file.name + file.lastModified}>
                <FileUploader file={file} />
              </div>
            ) : null}
            <Table />
          </div>
        </div>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Modals/StorageUploadModal/StorageUploadModal.jsx